import Vue from 'vue';
import axios from 'axios';
import {
  DELETE_POST,
  FETCH_POSTS_FAILED,
  FETCH_POSTS_SUCCESS,
  UNBAN_POST,
  TOGGLE_SPINNER,
} from '../mutation-types';

export const state = {
  all: [],
  isLoading: false,
};

export const mutations = {
  [FETCH_POSTS_SUCCESS](state, posts) {
    state.all = posts;
  },

  [UNBAN_POST](state, post) {
    let index = state.all.indexOf(post);
    Vue.set(state.all, index, post);
  },

  [FETCH_POSTS_FAILED](state) {
    state.all = [];
  },

  [DELETE_POST](state, post) {
    let index = state.all.indexOf(post);
    state.all.splice(index, 1);
  },

  [TOGGLE_SPINNER](state) {
    state.isLoading = !state.isLoading;
  },
};

export const actions = {
  async fetch({ commit }) {
    try {
      const { data: { data } } = await axios.get('/api/posts');
      commit(FETCH_POSTS_SUCCESS, data);
    } catch (e) {
      commit(FETCH_POSTS_FAILED);
    }
  },

  async unban({ dispatch, commit }, post) {
    try {
      dispatch('toggleSpinner');

      post.status = 'active';

      await axios.patch(`/api/posts/${post.id}/unban`);
      commit(UNBAN_POST, post);

      dispatch('toast', 'Post unflagged.', { root: true });
    } catch(e) {
      dispatch('toast', {
        message: 'Something went wrong.',
        type: 'is-danger'
      }, { root: true });
    } finally {
      dispatch('toggleSpinner');
    }
  },

  async destroy({ dispatch, commit }, post) {
    try {
      dispatch('toggleSpinner');

      await axios.delete(`/api/posts/${post.id}`);
      commit(DELETE_POST, post);

      dispatch('toast', 'Post deleted.', { root: true });
    } catch(e) {
      dispatch('toast', {
        message: 'Something went wrong.',
        type: 'is-danger'
      }, { root: true });
    } finally {
      dispatch('toggleSpinner');
    }
  },

  toggleSpinner({ commit }) {
    commit(TOGGLE_SPINNER);
  },
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/posts.js